export const endpoint = {
	login: "/api/login",
	loginVerify: "/api/login/verify",
	logout: "/api/logout",
	info: "/api/info",
	infoAll: "/api/info/all",
	authentication: "/api/auth",
	account: "/api/account",
	accountDownload: "/api/download_account",
	accountUpload: "/api/uplooad_account",
	brand: "/api/brand",

	laodActivity: "/api/load_activity",
	activity: "/api/activity",
	activityMember: "/api/activity-member",
	activityProgressStatus: "/api/activity-progress-status",
	activityStatus: "/api/activity-status",

	job: "/api/activity/:activityId/job",
	jobAll: "/api/job/all",
	jobSearch: "/api/job/search",
	jobDownload: "/api/job-download",
	jobStatus: "/api/job-status",
	jobDetail: "/api/job-detail",
	jobRoot: "/api/job",
	loadJob: "/api/activity/:activityId/load_job",

	question: "/api/question",

	application: "/api/application",
	checkApplication: "/api/check_application",
	approve: "/api/approve",

	concept: "/api/concept",
	conceptPreview: "/api/concept_preview",
	conceptImage: "/api/concept_image",

	staticImage: "/images",
	enquetePreview: "/enquete-preview",
	preview: "/api/preview",
	enqueteTest: "/api/enquete-test",

	quota: "/api/quota",
	invoice: "/api/invoice",

	// レポートページ
	outline: "/api/report/outline",
	exectiveReport: "/api/report/exective",
	evaluationReport: "/api/report/evaluation",
	conceptEvaluationReport: "/api/report/concept-evaluation",
	oaReport: "/api/report/oa",
	keyMeasurementsReport: "/api/report/key-measurements",
	resutByTargetReport: "/api/report/result-by-target",
	simulation: "/api/simulation",
	cp: "/api/simulation/cp",
	cpCorrectionValues: "/api/simulation/cp-correctionValues",

	downloadRawdata: "/api/download/rawdata",
	downloadQuestionSheet: "/api/download/question-sheet",

	passwordResetPage: "/password-reset",
	passwordReset: "/api/password-reset",

	aggregate: "/api/aggregate",
	aggregateDownload: "/api/download/aggregate",
	aggregateView: "/api/view/aggregate",

	conceptNorm: "/api/concept-norm",

	mfaDisable: "/api/mfa/disable",
	mfaReissueRecoveryCode: "/api/mfa/reissue-recovery-code",
	mfaReissueRecoveryCodeReq: "/api/mfa/reissue-recovery-code/request",
	mfaReset: "/api/mfa/reset",
	mfaResetRequest: "/api/mfa/reset/request",
	mfaResetVerify: "/api/mfa/reset/verify",
	mfaSetup: "/api/mfa/setup",
	mfaSetupRequest: "/api/mfa/setup/request",
	mfaSetupVerify: "/api/mfa/setup/verify",
	mfaVerify: "/api/mfa/verify",
	verificationChallengeIssue: "/api/verification-challenge/issue",
	verificationChallengeVerify: "/api/verification-challenge/verify",
} as const;

export type ServerEndpoint = keyof typeof endpoint;
export type ServerEndpointPath = (typeof endpoint)[ServerEndpoint];

export const replaceEndpointUrl = (url: string, params: { [key: string]: string }) => {
	let tmp = url;
	for (const [key, val] of Object.entries(params)) {
		const reg = new RegExp(":" + key);
		tmp = tmp.replace(reg, val);
	}
	return tmp;
};

export const publicApiEndpoint = {
	excludeEnqueteId: "/api/exclude-enquete",
} as const;

export const v3ApiEndpoint = {
	outline: "/api/v3/report/outline",
	executiveReport: "/api/v3/report/exectuive",
	oaReport: "/api/v3/report/oa",
	keyMeasurementsReport: "/api/v3/report/key-measurements",
	resutByTargetReport: "/api/v3/report/result-by-target",
	simulation: "/api/v3/simulation",
	// 現行品の補正係数
	cp: "/api/v3/simulation/cp",
	cpPurchaseRate: "/api/v3/simulation/cp/purchase-rate",
	cpRecognitionRate: "/api/v3/simulation/cp/recognition-ratge",
	/**
	 * エグセクティブサマリのCSVダウンロード
	 */
	downloadExecutiveReport: "/api/v3/download/report/executive",
} as const;
